import * as React from 'react';
import * as PropTypes from 'prop-types';
import PasswordInput from '../shared/password_input';

const GUEST_CHECKOUT_TYPE = 'guest';
const STANDARD_CHECKOUT_TYPE = 'standard';

class PasswordOrGuestCheckoutSelection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedCheckoutType: props.selectedCheckoutType,
    };

    this.toggleToStandardCheckout = this.toggleToStandardCheckout.bind(this);
    this.toggleToGuestCheckout = this.toggleToGuestCheckout.bind(this);
  }

  standardCheckoutSelected() {
    return (this.state.selectedCheckoutType === STANDARD_CHECKOUT_TYPE);
  }

  toggleToStandardCheckout(event) {
    event.preventDefault();
    this.setState({ selectedCheckoutType: STANDARD_CHECKOUT_TYPE });
  }

  toggleToGuestCheckout(event) {
    event.preventDefault();
    this.setState({ selectedCheckoutType: GUEST_CHECKOUT_TYPE });
  }

  renderAccountSection() {
    return (
      <div>
        <input
          type="hidden"
          name="checkout_type"
          value={STANDARD_CHECKOUT_TYPE}
        />
        <PasswordInput fieldName={this.props.passwordFieldName} />
        <div className="form-group">
          <div className="form-group__fields">
            <p className="mb-1">
              {I18n.t('js.bundledCheckout.passwordOrGuestCheckoutSelection.preferNotToCreate')}
              <button className="button-as-link ml-half weight-bold icon-r-arrow-right" onClick={this.toggleToGuestCheckout}>
                {I18n.t('js.bundledCheckout.passwordOrGuestCheckoutSelection.switchToGuest')}
              </button>
            </p>
          </div>
        </div>
      </div>
    );
  }

  renderGuestSection() {
    return (
      <div className="form-group">
        <div className="form-group__fields">
          <input
            type="hidden"
            name="checkout_type"
            value={GUEST_CHECKOUT_TYPE}
          />
          <p className="mb-1">
            {I18n.t('js.bundledCheckout.passwordOrGuestCheckoutSelection.wantAllReverbFeatures')}
            <button className="button-as-link ml-half weight-bold icon-r-arrow-right" onClick={this.toggleToStandardCheckout}>
              {I18n.t('js.bundledCheckout.passwordOrGuestCheckoutSelection.switchToCreateAccount')}
            </button>
          </p>
        </div>
      </div>
    );
  }

  render() {
    if (this.standardCheckoutSelected()) {
      return this.renderAccountSection();
    }

    return this.renderGuestSection();
  }
}

PasswordOrGuestCheckoutSelection.propTypes = {
  passwordFieldName: PropTypes.string.isRequired,
  selectedCheckoutType: PropTypes.string.isRequired,
};

export default PasswordOrGuestCheckoutSelection;



// WEBPACK FOOTER //
// ./javascripts/components/bundled_checkout/password_or_guest_checkout_selection.jsx